const PREFIX = 'cso_kiosk_';

const LocalStorageHelper = {
	/**
	 * Get the bearer token from local storage
	 * @returns {String} returns empty string if the item is not present
	 */
	getToken: () => {
		return localStorage.getItem(`${PREFIX}user_token`);
	},

	/**
	 * Set the bearer token to local storage
	 * @param {String} token
	 * @returns {void}
	 */
	setToken: (token) => {
		try {
			localStorage.setItem(`${PREFIX}user_token`, token);
		} catch (error) {
			console.log(error);
		}
	},

	/**
	 * Remove bearer token item from local storage
	 * @returns {void}
	 */
	removeToken: () => {
		localStorage.removeItem(`${PREFIX}user_token`);
	},

	/**
	 * Set the user data to the local storage
	 * @param {Object} user
	 * @returns {void}
	 */
	setUser: (user) => {
		// Wrap in a try-catch block to capture error when JSON.stringify fails
		try {
			localStorage.setItem(`${PREFIX}user`, JSON.stringify(user));
		} catch (error) {
			console.log(error);
		}

	},

	/**
	 * Get user data from local storage
	 * @returns {Object}
	 */
	getUser: () => {
		// Wrap in a try-catch block to capture error when JSON.parse fails
		try {
			const jsonUser = JSON.parse(localStorage.getItem(`${PREFIX}user`));
			return jsonUser;
		} catch (error) {
			console.log(error);
		}
	},

	/**
	 * Remove user item from local storage
	 * @returns {void}
	 */
	removeUser: () => {
		localStorage.removeItem(`${PREFIX}user`);
	}
};

export default LocalStorageHelper;
